import React from "react";
import "./styles.scss";
import { draggableMediaTypes } from "../../../../../api/media";

export default ({ label, onChange, name, className = "" }) => (
  <div
    id="uploading-flow-media-selector"
    className={"d-inline ml-3 mr-3 " + className}
  >
    <label htmlFor="file-input" className="btn btn-primary">
      {label}
      <input
        id="file-input"
        type="file"
        className="form-control-file"
        onChange={onChange}
        name={name}
        accept={draggableMediaTypes.join(",").toString()}
      />
    </label>
  </div>
);
